import { render, staticRenderFns } from "./PagePagination.vue?vue&type=template&id=de6252a6&scoped=true"
import script from "./PagePagination.vue?vue&type=script&lang=ts"
export * from "./PagePagination.vue?vue&type=script&lang=ts"
import style0 from "./PagePagination.vue?vue&type=style&index=0&id=de6252a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de6252a6",
  null
  
)

export default component.exports